import uuid4 from 'uuid4'

export const generateXRequestId = () => {
  if (window && window.__IFRAME_DEBUGGER_PARAMS) {
    return window.__IFRAME_DEBUGGER_PARAMS.shift() ?? uuid4()
  }
  return uuid4()
}
